module.exports = __webpack_public_path__ + "static/Java-63d1ba51e70162414576dd00095bee0d.mp4";